module.exports = __webpack_public_path__ + "img/logo.7af549a7.png";